<div class="tipShade" *ngIf="type==='tip'">
  <div class="tip {{theme}}">
    <div class="tiptxt" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" [innerHtml]="desText"></div>
    <div class="private" id="private" *ngIf="desText==='提交后不可以修改了哦'" (click)="check()" ><span>私密提交，你的作答其他学员<br>不可见</span></div>
    <button id="quitBtn" class="btnWord" (click)="sure()" *ngIf="sureText!=''">{{sureText}}</button>
    <button id="continueBtn" class="btnWord" (click)="cancel()" *ngIf="cancelText!=''">{{cancelText}}</button>
  </div>
</div>

<div class="toast {{theme}}" *ngIf="type==='toast'" [innerHTML]="desText" ></div>



// WEBPACK FOOTER //
// ./src/app/app-com-tip/app-com-tip.component.html